import {get_user_info} from '../api/index'
import {ACTION_GET_USER_INFO, USRE_INFO_LOAD, GET_ZP_INFO} from '../constant/eventbus'
import isString from 'lodash/isString'
import { show_login_expired} from '../tools/mgtv/login'
import {click_event, error_event} from '../tools/mgtv/analysis'

const EventUser = {
  install: function (EventBus) {
    EventBus.$on(ACTION_GET_USER_INFO, (ticket) => {
      if (!ticket) {
        window.$bus.$emit(GET_ZP_INFO);
        return;
      }
      get_user_info(ticket).then(res => {
        if (!res) {
          return;
        }

        if (res < 0) {
          return;
        }
        if (res.ret === 0) {

          const user_info = res.data.userinfo;
          let avatar = "//vipcdn.mgtv.com/mrdb/unionvip/imgs/mrtx1.png";
          let avatars = user_info.avatar;
          if (isString(avatars) && avatars.length > 0) {
            avatars = JSON.parse(avatars);
            if (avatars.l) {
              avatar = avatars.l.replace(/^http:\/\//, "https://");
            }
          }

          let vip_id = 0;
          let level = 0;
          const vipinfo = user_info.vipinfo;
          if (vipinfo) {
            switch (vipinfo.type) {
              case "2": //黄钻 mpp
                vip_id = 1;
                break;
              case "1"://紫钻 ott
                vip_id = 2;
                break;
              default:
                vip_id = 0;
                break;
            }
            level = vipinfo.growth ? vipinfo.growth.level : 0;
          }

          EventBus.$set(EventBus.user, 'uuid', user_info.uuid);
          EventBus.$set(EventBus.user, 'nickname', user_info.nickname);
          EventBus.$set(EventBus.user, 'avatar', avatar);
          EventBus.$set(EventBus.user, 'ticket', ticket);
          EventBus.$set(EventBus.user, 'vip_id', vip_id);
          EventBus.$set(EventBus.user, 'user_type', res.data.user_type);
          EventBus.$set(EventBus.user, 'level', level);

          EventBus.$emit(USRE_INFO_LOAD)
          window.$bus.$emit(GET_ZP_INFO);

          setTimeout(() => {
            click_event('成功获取用户信息')
          }, 0);
        } else {
          window.$bus.$emit(GET_ZP_INFO);
          show_login_expired();
        }

      }).catch(error => {
        error_event(error, {code_error: "EventUser.ACTION_GET_USER_INFO"});
        window.$bus.$emit(GET_ZP_INFO);
        show_login_expired();
      });
    });
  }
}

export default EventUser



// WEBPACK FOOTER //
// ./src/EventBus/EventUser.js